/* eslint-disable react-hooks/exhaustive-deps */
import ICONS from "../../../../../assets/Icons";
import GSTVerification from "../../../../../containers/Settings/GSTDetails";
import { GlobalConfiguration } from "../../../../../utils/configurationProvider";
import ConfirmBtnAccCreation from "../../../../_utils/AccountCreationComponents/ConfirmBtnAccCreation";
import GstDetails from "../../../../_utils/AccountCreationComponents/GstDetails";
import PanDetails from "../../../../_utils/AccountCreationComponents/PanDetails";
import ActiveInactiveAssociatePopup from "../../../../_utils/ActiveInactiveAssociatePopup";
import CommonLayout from "../../../../_utils/CommonLayout";
import LargePopupRedirect from "../../../../_utils/CommonPopups/CommonLargePopupRedirect";
import "./index.css";

const BeneficiaryAccountStepPAN = ({
  verifiedPan,
  panNumber,
  handlePANChange,
  panDetails,
  panLookupData,
  panLookupLoading,
  panLookupError,
  lookupNext,
  panVerificationLoading,
  payload,
  GSTStatus,
  accountActiveInactiveState,
  setAccountActiveInactiveState,
  currentAssociate,
  setCurrentAssociate,
  openAssociatePopup,
  setOpenAssociatePopup,
  navigate,
  showPopup,
  setShowPopup,
  gstVerificationData,
  gstVerified,
  gstVerificationLoading,
  GSTLinked,
  handleGSTChange,
  isConfirmDisabled,
  handlePANConfirm,
}) => {
  return (
    <div className="w-width-full">
      {showPopup && (
        <LargePopupRedirect
          headerTitle="GST Details"
          isfullViewrequired={true}
          fullviewhandleFunction={() =>
            navigate(`/settings/GST_verification`, {
              state: gstVerificationData?.gstin_details?.gstin_no,
            })
          }
          closeiconhandleFunction={() => setShowPopup(false)}
        >
          <GSTVerification
            gst_number={gstVerificationData?.gstin_details?.gstin_no}
            popup={true}
          />
        </LargePopupRedirect>
      )}

      <div className="px-padding-md lg:px-padding-base py-padding-md Qsmd:py-padding-base max-w-tab-width-normal w-full mx-auto Qsmd:!pb-padding-md">
        <CommonLayout>
          <div className="w-width-full lg:max-w-[var(--create-box-width)]">
            <PanDetails
              verifiedPan={verifiedPan}
              verifyPANisLoading={panVerificationLoading}
              panNumber={panNumber}
              handlePanChange={(e) => {
                handlePANChange(e);
              }}
              panDetails={panDetails}
            />
            <div
              className="w-width-full rounded-border-radius-md"
              style={{
                pointerEvents: !verifiedPan ? "none" : "auto",
                cursor: !verifiedPan ? "not-allowed" : "text",
                opacity: !verifiedPan
                  ? "var(--light-opacity)"
                  : "var(--base-opacity)",
              }}
            >
              <GstDetails
                verifiedPan={verifiedPan}
                gstVerified={gstVerified}
                beneVerifyGST={gstVerificationData}
                isGSTLoading={gstVerificationLoading}
                GSTLinked={GSTLinked}
                GstNumber={payload.gstin}
                setShowPopup={setShowPopup}
                handleChange={handleGSTChange}
              />
            </div>
          </div>

          <div className="w-width-full flex flex-col lg:max-w-[var(--create-box-width)]">
            {verifiedPan === true &&
              panLookupLoading === false &&
              panVerificationLoading === false && (
                <div style={{ overflow: "hidden" }}>
                  <div
                    className={
                      verifiedPan === false ? "" : "animate-slideInFromRight"
                    }
                  >
                    <ConfirmBtnAccCreation
                      type="pan"
                      status={panLookupData?.status}
                      lookupNext={lookupNext}
                      GSTStatus={GSTStatus}
                      isButtonDisabled={isConfirmDisabled}
                      isGSTLoading={gstVerificationLoading}
                      selected={ICONS?.SELECTED_WITH_GREEN_CIRCLE}
                      not_selected={ICONS?.NOT_SELECTED_WITH_GREY_CIRCLE}
                      handleClick={handlePANConfirm}
                    />
                  </div>
                </div>
              )}

            <div>
              <ActiveInactiveAssociatePopup
                flow={
                  verifiedPan === false
                    ? "hideAssociate"
                    : verifiedPan === null ||
                        panLookupLoading ||
                        panVerificationLoading
                      ? "defaultPan"
                      : !panLookupLoading &&
                          !panVerificationLoading &&
                          panLookupError === true &&
                          verifiedPan &&
                          panNumber?.length === GlobalConfiguration.panLength
                        ? "notFoundPan"
                        : "Pan"
                }
                dropDownNo={GlobalConfiguration?.lengthCheckZero}
                pan={payload?.panNumber}
                panLength={panNumber.length}
                accActiveInactiveState={accountActiveInactiveState}
                setAccActiveInactiveState={setAccountActiveInactiveState}
                currentAssociate={currentAssociate}
                setCurrentAssociate={setCurrentAssociate}
                openAssociatePopup={openAssociatePopup}
                setOpenAssociatePopup={setOpenAssociatePopup}
                currentRoute={"beneAccount"}
              />
            </div>
          </div>
        </CommonLayout>
      </div>
    </div>
  );
};
export default BeneficiaryAccountStepPAN;
